const extractOffset = (label) => {
  const matches = label.match(/([-+]?\d{1,2}):?(\d{2})?/)
  if (matches) {
    const hours = parseInt(matches[1], 10)
    const minutes = matches[2] ? parseInt(matches[2], 10) : 0
    return hours * 60 + minutes
  }
  return 0
}

const compareTimeZones = (a, b) => {
  const offsetA = extractOffset(a.label)
  const offsetB = extractOffset(b.label)
  return offsetA - offsetB
}

export default compareTimeZones
